// STEP 7d · D-e — the specific-vouching panel says which lines the sheet takes (all categories / one category). EN + AR.
import React from "react";
import { categoryForBody } from "@/pages/Sampling/specificCategory";

export default function SpecificCategoryNote({ form, t }) {
  const cat = categoryForBody(form);
  return (
    <div className="mt-1 text-[11px]" data-testid="samp-specific-category-note">
      {cat ? t("s7dde.specific.oneCategory").replace("{cat}", cat) : t("s7dde.specific.allLines")}
    </div>
  );
}
